
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/x/api/data-grid/grid-charts-renderer-proxy",
      function () {
        return require("private-next-pages/x/api/data-grid/grid-charts-renderer-proxy.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/x/api/data-grid/grid-charts-renderer-proxy"])
      });
    }
  